<script setup lang="ts">
	const x = shallowRef(0)
	const { isActive } = reactor(useNotificationActivities())
	const { toggle } = useNotificationActivities()
	const activeTab = shallowRef('todo')
	const notificationTab = ref<lineTabContext[]>([
		{
			key: 'todo',
			name: 'Key To dos'
		},
		{
			key: 'activities',
			name: 'Activities'
		}
	])
</script>

<template>
	<div
		class="overlay custom-transition fixed right-0 top-0 !z-[100] h-full w-full scale-[1] bg-[rgba(0,0,0,0.5)]"
		:class="{
			'opacity-0': !isActive,
			'-scale-90': !isActive,
			'pointer-events-none': !isActive
		}"
	>
		<transition
			name="animate"
			enter-active-class="animate__animated animate__backInDown  animate__faster-x2"
			leave-active-class="animate__animated animate__backOutDown animate__faster-x2"
		>
			<ul
				v-if="isActive"
				class="menuTip absolute right-2 top-24 z-[500] h-full min-h-[509px] w-full max-w-[476px] rounded bg-white"
				:class="`after:left-[${x || 50}px]`"
			>
				<div class="h-fit max-h-[90%] w-full overflow-y-auto p-5">
					<div class="mb-5 flex items-center justify-between">
						<h3 class="font-medium tracking-wide text-gray-600 sm:text-lg">Notifications</h3>
						<button
							type="button"
							name="close notification"
							class="flex h-[28px] w-[28px] items-center justify-center rounded-full bg-gray-100"
							@click="toggle"
						>
							<lazy-tools-icon icon="cancel" :height="16" :width="16" dir="line" />
						</button>
					</div>
					<tabs-line-tab
						v-model:active-tab="activeTab"
						:tabs="notificationTab"
						query-key="notify"
						:ui="{
							tab: {
								display: 'justify-between flex items-center',
								width: 'w-full',
								active: {
									color: 'text-primary-2',
									default: 'font-semibold '
								}
							}
						}"
						tab-body-class="overflow-y-auto max-h-[600px]"
					>
						<template #head-section>
							<div
								class="mt-3 min-h-[65px] w-full border border-gray-100 bg-gray-200 p-5 text-sm font-medium leading-[18px] text-gray-500"
							>
								All notifications will remain here and will only go away after 30 days.
							</div>
						</template>

						<template #todo>
							<layout-notification-todo class="pt-5" />
						</template>
						<template #activities>
							<div class="max-h-[500px] overflow-y-auto pb-12">
								<layout-notification-activities class="pt-5" :wrap="true" />
							</div>
						</template>
					</tabs-line-tab>
				</div>
			</ul>
		</transition>
	</div>
</template>

<style scoped>
	.menuTip::after {
		content: '';
		border-width: 20px;
		border-style: solid;
		transition: 500ms ease-in-out;
		border-color: transparent transparent #fff transparent;
		@apply absolute left-[90%] top-[-40px] z-[200] ml-[-5px] md:left-[60%];
	}
</style>
